import React, {useState, useContext} from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles"
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import {getCode} from "../../api/db";
import Typography from "@mui/material/Typography";
import {red} from '@mui/material/colors';
import {styled} from '@mui/material/styles';
import {CircularProgress} from "@mui/material";
import Grid from "@mui/material/Grid/Grid";

const ColorButton = styled(Button)(({theme}) => ({
    fontSize: 32,
    backgroundColor: red[500],
    '&:hover': {
        backgroundColor: red[700],
    },
}));


export const Activate = ({form, code}) => {
        // const registerEyespy = async () => {
        //     if(window.parent){
        //         return window.parent.location.href = `https://e3.eyespy360.com/p/autosign_promo.pl?email=${encodeURI(form.email)}&referrer=photographer&code=${code}`
        //     }
        //
        //     window.location.href = `https://e3.eyespy360.com/p/autosign_promo.pl?email=${encodeURI(form.email)}&referrer=photographer&code=${code}`
        // }

        return (<Container maxWidth={'md'}>
            <Box display={"flex"}
                flexDirection={"column"}
                style={{textAling: 'center'}}
                alignItems={"center"}>
                <CircularProgress />
            </Box>
        </Container>)

        // return (<Container maxWidth={'md'}><Box display={"flex"}
        //                                         flexDirection={"column"}
        //                                         style={{textAling: 'center'}}
        //                                         alignItems={"center"}>
        //     <Box><Typography variant={'h3'}>Thanks for completing this form.</Typography></Box><br/>
        //     <Box><Typography variant={'h6'}>We’ll be in touch with you over the next few days to introduce you to your
        //         account manager, discuss our photography network and to answer any questions you may
        //         have.</Typography></Box><br/>
        //     <Box><Typography variant={'h6'}>Now, simply click on the following button to activate your free EyeSpy360
        //         Account!</Typography></Box><br/>
        //     <ColorButton
        //         variant="contained"
        //         onClick={(e) => registerEyespy(e)}
        //     >
        //         Activate
        //     </ColorButton>
        //     <br/>
        //     <Box><Typography variant={'h6'} style={{textAlign: "center"}}>Don’t forget your first Virtual Tour is 100% FREE! <div>(up to 20 images)</div></Typography></Box><br/>
        //     <Box><Typography variant={'h6'}>Keep an eye on your inbox. We’ll shortly be sending you an email so you can set your own password, plus a further email with our best practice guide (BPG). The BPG will show you exactly how to capture your 360 images ready to upload to the EyeSpy360 platform.</Typography></Box><br/>
        //     <Box><Typography variant={'h6'}>Should you have any questions in the interim, please don’t hesitate to get in touch either by email, telephone, online chat or our Apple SMS Chat, all details of which can be found below.</Typography></Box><br/>
        // </Box></Container>)
    }
;